class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    function updateFacetCounts(facetRemoveCount) {
      // Update the text content for facetCountSpan and all elements with the class "count-for-count"
      const facetCountSpan = document.querySelector("#FacetFiltersFormMobile #facetCountSpan");
      if (facetCountSpan) {
        facetCountSpan.textContent = `(${facetRemoveCount})`;
      }
      document.querySelectorAll(".count-for-count").forEach(el => {
        el.textContent = `(${facetRemoveCount})`;
      });
    }
    
    function updateFacetStyles(facetRemoveCount) {
      const containerNew = document.querySelector('.active-facets.active-facets-mobile.medium-hide.large-up-hide');
      const clearAllButton = document.querySelector('#FacetFiltersFormMobile #clearAllButton');
      const facetCountSpan = document.querySelector("#FacetFiltersFormMobile #facetCountSpan");
    
      if (facetRemoveCount === 0) {
        if (containerNew) {
          containerNew.style.padding = "0";
        }
        if (clearAllButton) {
          clearAllButton.style.display = "none";
        }
        if (facetCountSpan) {
          facetCountSpan.textContent = "(0)";
          facetCountSpan.classList.remove('append-circle');
        }
        document.querySelectorAll(".count-for-count").forEach(el => {
          el.textContent = "(0)";
          el.classList.remove('append-circle');
        });
      } else {
        if (containerNew) {
          containerNew.style.padding = "2rem 2rem 0";
        }
        if (clearAllButton) {
          clearAllButton.style.display = "block";
        }
        if (facetCountSpan) {
          facetCountSpan.classList.add('append-circle');
        }
        document.querySelectorAll(".count-for-count").forEach(el => {
          el.classList.add('append-circle');
        });
      }
    }
    
    function updateFacets() {
      const facetRemoveCount = document.querySelectorAll('.results_active_values .active-facets__button-inner').length;
      updateFacetCounts(facetRemoveCount);
      updateFacetStyles(facetRemoveCount);
    }
  
    updateFacets();
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        currentElement.querySelectorAll('.desk-range, .mob-range').forEach((container) => {
          delete container.dataset.rangeReady;
        });
        currentElement.querySelectorAll('price-range').forEach((priceRange) => {
          if (typeof priceRange.initRange === 'function') priceRange.initRange();
        });
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    mobileForm?.closest('menu-drawer')?.bindEvents?.();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
// function changeView(viewClass, button) {
//   const productGrid = document.getElementById('ProductGridContainer');
//   const threeButton = document.querySelector('.card-view.three');
//   const fourButton = document.querySelector('.card-view.four');

//   // Check if the button already has the view-active class
//   if (button.classList.contains('view-active')) {
//     // Disable the onclick functionality
//     return;
//   }

//   // Remove active class from both buttons
//   threeButton.classList.remove('view-active');
//   fourButton.classList.remove('view-active');

//   // Toggle the view class on the product grid
//   if (productGrid.classList.contains(viewClass)) {
//     productGrid.classList.remove(viewClass);
//   } else {
//     // Remove the existing view class
//     productGrid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
//     productGrid.classList.add(viewClass);

//     // Add the active class to the clicked button
//     button.classList.add('view-active');
//   }
// }
// function mobilechangeView(viewClass, button) {
//   const productGrid = document.getElementById('ProductGridContainer');
//   const oneButton = document.querySelector('.card-view.one');
//   const twoButton = document.querySelector('.card-view.two');

//   // Check if the button already has the view-active class
//   if (button.classList.contains('view-active')) {
//     // Disable the onclick functionality
//     return;
//   }

//   // Remove active class from both buttons
//   oneButton.classList.remove('view-active');
//   twoButton.classList.remove('view-active');

//   // Toggle the view class on the product grid
//   if (productGrid.classList.contains(viewClass)) {
//     productGrid.classList.remove(viewClass);
//   } else {
//     // Remove the existing view class
//     productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
//     productGrid.classList.add(viewClass);

//     // Add the active class to the clicked button
//     button.classList.add('view-active');
//   }
// }


FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.onInput = this.onInput.bind(this);
    this.querySelectorAll('input[type="number"]').forEach((input) => input.addEventListener('change', this.onInput));
  }

  connectedCallback() {
    this.initRange();
  }

  initRange() {
    const container = this.closest('.desk-range, .mob-range');
    if (!container || container.dataset.rangeReady === 'true') return;

    const isMobile = container.classList.contains('mob-range');
    const leftRange = container.querySelector('.left-range');
    const rightRange = container.querySelector('.right-range');
    const minInput = container.querySelector(isMobile ? '.min-price-input-mob' : '.min-price-input');
    const maxInput = container.querySelector(isMobile ? '.max-price-input-mob' : '.max-price-input');

    if (!leftRange || !rightRange || !minInput || !maxInput) return;

    container.dataset.rangeReady = 'true';

    const syncFromSliders = (triggerInputEvent = false) => {
      const max = parseFloat(leftRange.max) || 1;
      let minVal = parseFloat(leftRange.value);
      let maxVal = parseFloat(rightRange.value);

      if (minVal > maxVal) {
        if (document.activeElement === leftRange) {
          maxVal = minVal;
          rightRange.value = maxVal;
        } else {
          minVal = maxVal;
          leftRange.value = minVal;
        }
      }

      const leftPer = (minVal / max) * 100;
      const rightPer = (maxVal / max) * 100;

      leftRange.style.setProperty('--left-per', `${leftPer}%`);
      leftRange.style.setProperty('--right-per', `${rightPer}%`);
      rightRange.style.setProperty('--left-per', `${leftPer}%`);
      rightRange.style.setProperty('--right-per', `${rightPer}%`);

      minInput.value = Math.round(minVal);
      maxInput.value = Math.round(maxVal);

      if (triggerInputEvent) {
        minInput.dispatchEvent(new Event('input', { bubbles: true }));
        maxInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    const syncFromInputs = () => {
      leftRange.value = minInput.value || leftRange.min;
      rightRange.value = maxInput.value || rightRange.max;
      syncFromSliders(false);
    };

    leftRange.addEventListener('input', () => syncFromSliders(true));
    rightRange.addEventListener('input', () => syncFromSliders(true));
    minInput.addEventListener('input', syncFromInputs);
    maxInput.addEventListener('input', syncFromInputs);

    syncFromSliders(false);
  }

  onInput(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[type="number"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

